import { ReactComponent as UrgentIcon } from '../assets/svg/urgent.svg';
import { ReactComponent as ImportantIcon } from '../assets/svg/important.svg';
import { ReactComponent as MediumIcon } from '../assets/svg/medium.svg';
import { ReactComponent as LowIcon } from '../assets/svg/low.svg';

// import { ReactComponent as CircleIcon } from '../assets/svg/circle.svg';
import { ReactComponent as InProgressIcon } from '../assets/svg/in-progress.svg';
import { ReactComponent as CompletedIcon } from '../assets/svg/completed.svg';

export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  STAFF: 'staff',
};

export const TASK_STATUS_COLORS = {
  completed: '#4CAF50',
  inProgress: '#9E9E9E',
  overdue: '#F44336',
  pending: '#FF9800',
  scheduled: '#B0BEC5',
  unassigned: '#577590',
};

export const PriorityOptions = [
  {
    label: 'Urgent',
    value: 0,
    icon: <UrgentIcon color="rgb(203, 69, 94)" />,
  },
  {
    label: 'Important',
    value: 1,
    icon: <ImportantIcon color="rgb(203, 69, 94)" />,
  },
  {
    label: 'Medium',
    value: 2,
    icon: <MediumIcon color="rgb(65, 128, 64)" />,
  },
  {
    label: 'Low',
    value: 3,
    icon: <LowIcon color="rgb(50, 126, 170)" />,
  },
];

export const ProgressOptions = [
  // {
  //   label: 'Not Started',
  //   value: 'not-started',
  //   icon: <CircleIcon color="rgb(151, 150, 147)" />,
  // },
  {
    label: 'Pending',
    value: 0,
    icon: <InProgressIcon color="rgb(92, 169, 229)" />,
  },
  {
    label: 'Completed',
    value: 1,
    icon: <CompletedIcon color="rgb(166, 167, 220)" />,
    disabled: true,
  },
];

export const RepeatOptions = [
  {
    label: 'Does not repeat',
    value: 'does-not-repeat',
  },
  {
    label: 'Daily',
    value: 'daily',
  },
  {
    label: 'Weekdays',
    value: 'weekdays',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Yearly',
    value: 'yearly',
  },
  {
    label: 'Custom',
    value: 'custom',
  },
];

export const initialLabels = [
  { label: 'Urgent', color: '#FF4D4F' }, // Red
  { label: 'Important', color: '#FAAD14' }, // Orange
  { label: 'Medium', color: '#1890FF' }, // Blue
  { label: 'Low', color: '#52C41A' }, // Green
];

export const repeatOptions = [
  { label: 'Day', value: 'day' },
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
  { label: 'Year', value: 'year' },
];

export const weekShortOptions = [
  { label: 'Sun', value: 'Sunday' },
  { label: 'Mon', value: 'Monday' },
  { label: 'Tue', value: 'Tuesday' },
  { label: 'Wed', value: 'Wednesday' },
  { label: 'Thu', value: 'Thursday' },
  { label: 'Fri', value: 'Friday' },
  { label: 'Sat', value: 'Saturday' },
];

export const weekLongOptions = [
  { label: 'Sunday', value: 'Sunday' },
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
];

export const ordinalOptions = [
  { label: 'First', value: 'First' },
  { label: 'Second', value: 'Second' },
  { label: 'Third', value: 'Third' },
  { label: 'Fourth', value: 'Fourth' },
  { label: 'Last', value: 'Last' },
];

export const monthOptions = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
];

export const rolesOption = [
  {
    label: 'SUPER ADMIN',
    value: 0,
  },
  {
    label: 'ADMIN',
    value: 1,
  },
  {
    label: 'MANAGER',
    value: 2,
  },
  {
    label: 'STAFF',
    value: 3,
  },
];

export const genderOption = [
  {
    label: 'MALE',
    value: 'male',
  },
  {
    label: 'FEMALE',
    value: 'female',
  },
  {
    label: 'OTHER',
    value: 'other',
  },
];

export const TASk_TABS = {
  DASHBOARD: 'dashboard',
  PENDING: 'pending',
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled',
  ARCHIVED: 'archived',
};